const headers = {
  Accept: 'application/json',
};

export default function fetcher(path) {
  const requestHeaders = { ...headers };
  if (path.startsWith('/api/')) {
    requestHeaders['secret-key'] = '6-VUdzeFZooiU_wJNVho';
  }

  return fetch(path, {
    headers: requestHeaders,
    method: 'GET',
    credentials: 'omit',
  }).then((res) => res.json());
}
